import React from "react";
import SEO from "../../components/common/SEO";
import { seoMetadata } from "../../data/seoMetadata";
import VideoSection from "../../components/homepage/VideoSection";
import QuickHighlights from "../../components/homepage/QuickHighlights";
import EventsSection from "../../components/homepage/EventsSection";

const LandingPage: React.FC = () => {
  const metadata = seoMetadata.home;

  return (
    <>
      <SEO
        title={metadata.title}
        description={metadata.description}
        keywords={metadata.keywords}
        canonical={metadata.canonical}
        ogImage={metadata.ogImage}
        ogType={metadata.ogType}
      >
        {/* JSON-LD Organization Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "ByteMonk",
            alternateName: "ByteMonk Technology Club",
            url: "https://bytemonk-gcect.web.app",
            logo: "https://bytemonk-gcect.web.app/og-image.png",
            description:
              "ByteMonk is the premier technology club of Government College of Engineering and Ceramic Technology (GCECT), Kolkata.",
            address: {
              "@type": "PostalAddress",
              addressLocality: "Kolkata",
              addressRegion: "West Bengal",
              addressCountry: "IN",
            },
            sameAs: [
              "https://www.instagram.com/gcect.tech.club/",
              "https://www.linkedin.com/company/Bytemonk/",
            ],
            parentOrganization: {
              "@type": "EducationalOrganization",
              name: "Government College of Engineering and Ceramic Technology",
              alternateName: "GCECT",
            },
          })}
        </script>

        {/* JSON-LD WebSite Schema — enables sitelinks search box */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: "ByteMonk",
            url: "https://bytemonk-gcect.web.app",
            potentialAction: {
              "@type": "SearchAction",
              target:
                "https://bytemonk-gcect.web.app/events?q={search_term_string}",
              "query-input": "required name=search_term_string",
            },
          })}
        </script>
      </SEO>

      <main
        className="m-0 p-0"
        style={{
          width: "100%",
          overflowX: "hidden",
          background: "#000",
        }}
      >
        <h1 className="visually-hidden">ByteMonk - Technology Club of GCECT</h1>
        <VideoSection />
        <QuickHighlights />
        <EventsSection />
      </main>
    </>
  );
};

export default LandingPage;
